export { default } from './VehicleSlider';
